import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackageOpinionProps {
    items?: CuratedStory[];
}

export default function integrityCheck({
    items,
}: StoryPackageOpinionProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["byline", "headline"]);
}
